import React from "react";
import { FaGithub } from "react-icons/fa";
import { CgFileDocument } from "react-icons/cg";

const ProjectBox = ({ projectPhoto, projectName }) => {
  const desc = {
    EcommerceWebsiteDesc:
      "Excited to introduce Epic Gadgets Hub, an e-commerce platform blending tech and innovation! Discover a curated selection of cutting-edge electronics, all within a seamless and secure shopping experience. Explore the future of gadgets and embrace the evolving tech landscape with us. Your journey into innovation starts now!",
    EcommerceWebsiteGithub: "https://github.com/gopimishra71",
    EcommerceWebsiteWebsite: "https://tinyurl.com/epicgadgetshub",

    MyPortfolioWebsiteDesc:
      "I’m proud to present my customized portfolio website, designed to showcase my professional accomplishments, skills, and experiences. This dynamic platform reflects my journey and aspirations, offering a comprehensive view of my career and creative endeavors. Explore my work and witness how I bring my visions to life!",
    MyPortfolioWebsiteGithub: "https://github.com/gopimishra71/portfolio",
    MyPortfolioWebsiteWebsite: "https://tinyurl.com/gopimishra",

    ArtistPortfolioDesc:
      "Introducing my new project: a bespoke portfolio website tailored for artists and graphic designers. Designed to showcase your talents with elegance and clarity, this platform highlights your unique style professionally. Let’s collaborate to elevate your online presence and ensure your work truly shines in the digital landscape!",
    ArtistPortfolioGithub: "https://github.com/gopimishra71",
    ArtistPortfolioWebsite: "https://tinyurl.com/ayushmishrawebsite",

    SmallBusinessWebsiteDesc:
      "I’m thrilled to have crafted a bespoke website for a dynamic social media agency. This platform effectively represents and promotes their expertise in social media marketing, providing a compelling digital presence. It highlights their services and showcases their commitment to helping businesses thrive in the ever-evolving digital landscape.",
    SmallBusinessWebsiteGithub: "https://github.com/gopimishra71",
    SmallBusinessWebsiteWebsite: "https://tinyurl.com/teamofgmam",

    YouTubeChannelsWebsiteDesc:
      "I've had the opportunity to design and develop websites for various YouTube channels, enhancing their online presence and engagement. These tailored platforms provide viewers a dedicated space to explore content, connect with creators, and stay updated on the latest uploads. It's rewarding to contribute to their growth in the digital landscape!",
    YouTubeChannelsWebsiteGithub: "https://github.com/gopimishra71",
    YouTubeChannelsWebsiteWebsite: "https://tinyurl.com/ccteamyt",
  };

  let show = "";
  if (desc[projectName + "Github"] === "") {
    show = "none";
  }

  return (
    <div className="projectBox">
      <img className="projectPhoto" src={projectPhoto} alt="Project display" />
      <div>
        <br />
        <h3>{projectName}</h3>
        <br />
        {desc[projectName + "Desc"]}
        <br />

        <a
          style={{ display: show }}
          href={desc[projectName + "Github"]}
          target="_blank"
        >
          <button className="projectbtn">
            <FaGithub /> Github
          </button>
        </a>

        <a href={desc[projectName + "Website"]} target="_blank">
          <button className="projectbtn">
            <CgFileDocument /> Demo
          </button>
        </a>
      </div>
    </div>
  );
};

export default ProjectBox;
